const aboutEN = {
	title: "About Sin Fila",

	/* Section eyebrows — short, uppercase labels above each heading */
	eyebrows: {
		mission: "Our Mission",
		founder: "The Founder",
		pillars: "Who It's For",
		vision: "What's Next",
		join: "Get Started",
	},

	hero: {
		tagline: "A Dominican company, built for Dominican businesses.",
		intro: "Sin Fila was created with one mission: to help Dominican businesses modernize the way they manage appointments and grow. We are proudly registered in the Dominican Republic and committed to supporting local entrepreneurs with technology designed around the realities of doing business here.",
		founder: "Behind Sin Fila is a Dominican founder with more than 10 years of experience building digital products and leading technology initiatives for Fortune 500 organizations. That global experience has been brought home to create a platform that is simple, reliable, and purpose-built for the Dominican market.",
		founderMeta: "Dominican founder · 10+ years building digital products",
		vision: "Our vision is to become the trusted technology partner for thousands of Dominican businesses, helping them grow, serve more customers, and embrace the future with confidence.",
		flag: "Proudly built and registered in the Dominican Republic",
		primaryCta: "List your business",
		secondaryCta: "Explore businesses",
		/* Identity panel beside the hero copy — every row restates a fact from the copy above. */
		identity: [
			{ label: "Based in", value: "Dominican Republic" },
			{ label: "Company", value: "Registered in the DR" },
			{ label: "Built with", value: "React + AWS" },
		],
	},

	whoWeAre: {
		title: "Who We Are",
		text: "Sin Fila is a modern booking platform created to simplify how people schedule appointments with service professionals. No more waiting, guessing availability, or messaging back and forth. Our goal is to make the entire scheduling experience effortless for both clients and businesses.",
	},

	pillars: {
		title: "Built for both sides of the appointment",
		subtitle: "One platform that works as well for the person booking as it does for the business taking the booking.",
	},

	clients: {
		title: "For Clients",
		label: "Clients",
		text: "Quickly find and book appointments with trusted professionals across multiple industries. View real availability, choose your preferred time, receive automatic reminders, and manage everything from your phone. Fast, simple, and convenient.",
	},

	staff: {
		title: "For Professionals & Business Owners",
		label: "Businesses",
		text: "Manage your schedule, reduce no-shows, and grow your business with powerful tools for appointments, services, staff, payments, and client communication. Sin Fila brings organization, automation, and efficiency to keep your business running smoothly.",
	},

	tech: {
		title: "Technology & Reliability",
		label: "Platform",
		text: "Powered by modern technologies such as React and AWS, Sin Fila is designed for speed, security, and scalability. We prioritize stability and reliability so clients and professionals can trust the platform every day.",
	},

	future: {
		title: "Future Vision",
		text: "We are continuously improving, preparing to release full mobile apps, expanding into new categories, and adding advanced features for businesses of all sizes. The platform will evolve with the needs of our community.",
		roadmap: [
			{
				title: "Native mobile apps",
				desc: "Full iOS and Android apps so clients and businesses can manage everything on the go.",
			},
			{
				title: "More categories",
				desc: "Expanding beyond our first industries to every kind of appointment-based business.",
			},
			{
				title: "Advanced tools",
				desc: "Deeper reporting, marketing and automation features for businesses of all sizes.",
			},
		],
	},

	joinUs: {
		title: "Join Us",
		text: "Whether you're a client looking for trusted professionals or a business wanting better tools, Sin Fila is here to make your life easier. Start today and experience a smarter way to book.",
	},
};

export default aboutEN;
